import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=5a55216e"
import script from "./ErrorBanner.vue?vue&type=script&lang=js"
export * from "./ErrorBanner.vue?vue&type=script&lang=js"
import style0 from "./ErrorBanner.vue?vue&type=style&index=0&id=5a55216e&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a55216e')) {
      api.createRecord('5a55216e', component.options)
    } else {
      api.reload('5a55216e', component.options)
    }
    module.hot.accept("./ErrorBanner.vue?vue&type=template&id=5a55216e", function () {
      api.rerender('5a55216e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ErrorBanner.vue"
export default component.exports